import service from "../service";

const message = error => (error.response && error.response.data && error.response.data.message) || "Não foi possível carregar a Conta SCN";

export const actions = {
  async loadWallet({ commit }) {
    commit("WALLET_LOADING", true);
    commit("WALLET_ERROR", null);
    try {
      const [account, transactions] = await Promise.all([service.account(), service.transactions({ page: 1, limit: 20 })]);
      commit("WALLET_ACCOUNT", account.data);
      commit("WALLET_TRANSACTIONS", transactions.data);
    } catch (error) {
      commit("WALLET_ERROR", message(error));
      throw error;
    } finally {
      commit("WALLET_LOADING", false);
    }
  }
};
